// extracted by mini-css-extract-plugin
export default {"teamDiv":"Team_teamDiv__cuoEZ","cardsWrapper":"Team_cardsWrapper__ILzVC"};